import axios from 'axios'
import accents from 'remove-accents'
import shuffle from 'shuffle-array'

export default {
  namespaced: true,
  state: {
    graduates: {
      data: [],
      showMore: false
    },
    limit: 12,
    detailLimit: 4,
    total: 0,
    searchString: '',
    profession: null
  },
  getters: {
    filter: state => {
      let graduates = state.graduates.data

      if (state.profession && graduates) {
        graduates = graduates.filter(graduate => {
          return graduate.profession_global_id === state.profession.id
        })
      }

      if (state.searchString && graduates) {
        const searchString = accents.remove(state.searchString.toLowerCase())

        graduates = graduates.filter(graduate => {
          return graduate.search.includes(searchString)
        })
      }

      return graduates
    },
    get: (state, getters) => {
      if (!getters.filter) {
        return { data: [], showMore: false }
      }
      let graduates = getters.filter
      const total = graduates.length

      graduates = graduates.slice(0, state.limit)

      return {
        data: graduates,
        showMore: total > graduates.length
      }
    },
    getById: state => id => {
      return state.graduates.data.find(graduate => graduate.id === id)
    },
    getPrev: (state, getters) => id => {
      const graduates = getters.filter
      let index = graduates.findIndex(graduate => graduate.id === id)

      if (index === 0) {
        index = graduates.length - 1
      } else {
        index--
      }

      const graduate = getters.filter[index]

      return graduate.id
    },
    getNext: (state, getters) => id => {
      const graduates = getters.filter
      let index = graduates.findIndex(graduate => graduate.id === id)

      if (index === graduates.length - 1) {
        index = 0
      } else {
        index++
      }

      const graduate = getters.filter[index]

      return graduate.id
    },
    getByProfession: state => (professionId, graduateId) => {
      let graduates = state.graduates.data

      graduates = graduates.filter(
        graduate => graduate.profession_global_id === professionId
      )

      graduates = graduates.filter(graduate => graduate.id != graduateId)

      const total = graduates.length

      graduates = graduates.slice(0, state.detailLimit)

      return {
        data: graduates,
        showMore: total > graduates.length
      }
    },
    getSearchString: state => {
      return state.searchString
    },
    displayMore: state => {
      return state.limit < state.total
    },
    profession: state => {
      return state.profession
    }
  },
  actions: {
    load: ({ commit }) => {
      axios
        .get(process.env.VUE_APP_API + `/graduates?_format=json`)
        .then(graduates => {
          let data = {}

          graduates.data.forEach(graduate => {
            if (!data[graduate.id]) {
              data[graduate.id] = { ...graduate, ...{ pictures_list: [] } }
            }

            data[graduate.id]['pictures_list'].push(graduate.pictures)
          })

          commit('setGraduates', Object.values(data))
        })
    },
    increaseLimit: ({ state, commit }) => {
      const limit = (state.limit = state.limit + 12)
      commit('setLimit', limit)
    },
    resetLimit: ({ commit }) => {
      commit('setLimit', 12)
    },
    setLimit: ({ commit }, limit) => {
      commit('setLimit', limit)
    },
    increaseDetailLimit: ({ state, commit }) => {
      const limit = (state.detailLimit = state.detailLimit + 4)
      commit('setDetailLimit', limit)
    },
    resetDetailLimit: ({ commit }) => {
      commit('setDetailLimit', 4)
    },
    search: ({ commit }, string) => {
      commit('setSearchString', string)
      commit('setLimit', 12)
    },
    filter: ({ commit }, profession) => {
      commit('setProfession', profession)
    }
  },
  mutations: {
    setGraduates: (state, graduates) => {
      graduates = graduates.map(graduate => {
        const search = accents.remove(
          graduate.firstname.toLowerCase() +
            ' ' +
            graduate.lastname.toLowerCase()
        )

        return { ...graduate, ...{ search } }
      })

      shuffle(graduates)
      state.graduates.data = graduates
    },
    setLimit: (state, limit) => {
      state.limit = limit
    },
    setDetailLimit: (state, limit) => {
      state.detailLimit = limit
    },
    setProfession: (state, profession) => {
      state.profession = profession
    },
    setSearchString: (state, string) => {
      state.searchString = string
    },
    setTotal: (state, total) => {
      state.total = total
    }
  }
}
